<template lang="html">

  <div class="download-pdf">
    <a class="pdf column-center" :href="server+data.archivo" target="_blank">
      <img :src="`/static/img/novedades-${lang}.webp`" alt=""/>
      <p>{{data.name}}</p>
    </a>
  </div>

</template>

<script lang="js">

  import { mapGetters } from 'vuex'


  export default  {
    name: 'tip-novedad',
    props: ['data'],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {
     ...mapGetters({
      server : 'getServer',
      lang : 'getLanguage'
    }),
   }
 }
</script>

<style scoped>

img{
  max-width: 100%;
}

.download-pdf{
  padding: 0;
}

.download-pdf .pdf{
  padding-bottom: 0px;
  background: none;
  display: flex;
  flex-direction: column;
}

.download-pdf .pdf p{
  padding: 10px 10px 40px 10px;
  margin-top: 0;
  flex-grow: 2;
  background: #E6ECF1 url(/static/img/arrow-down.svg) center calc(100% - 10px) no-repeat;

}

@media screen and (max-width: 768px){
  .download-pdf{
    width: 100%;
    margin-bottom: 20px;
    padding: 0;
  }

  .download-pdf:last-of-type{
    width: 100%;
    margin-bottom: 0;
    padding: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/view-parts/area-tecnica/tip-novedad.vue